/* prettier-ignore */

export const TIME_24H_INT = [
    9, 
    10, 
    11, 
    12, 
    13, 
    14, 
    15, 
    16, 
    17, 
    18, 
    19, 
    20, 
    21, 
    22, 
    23, 
    0
];

export const TIME_STRINGS = [
    '9 AM', 
    '10 AM', 
    '11 AM', 
    '12 PM', 
    '1 PM', 
    '2 PM', 
    '3 PM', 
    '4 PM', 
    '5 PM', 
    '6 PM', 
    '7 PM', 
    '8 PM', 
    '9 PM', 
    '10 PM', 
    '11 PM', 
    '12 AM'
];

// export const TIME_STRINGS = [
//     '9:00',
//     '9:30',
//     '10:00',
//     '10:30',
//     '11:00',
//     '11:30',
//     '12:00',
//     '12:30',
//     '13:00',
//     '13:30',
//     '14:00',
//     '14:30',
//     '15:00',
//     '15:30',
//     '16:00',
//     '16:30',
//     '17:00',
//     '17:30',
//     '18:00',
//     '18:30',
//     '19:00',
//     '19:30',
//     '20:00',
//     '20:30',
//     '21:00',
//     '21:30',
//     '22:00',
//     '22:30',
//     '23:00',
//     '23:30',
//     '00:00',
//     '00:30'
// ];

export const SIZE_CARDS = { 
    0: 100, 
    1: 100, 
    2: 215, 
    3: 330, 
    4: 445, 
    5: 560, 
    6: 675, 
    7: 790, 
    8: 905, 
    9: 1020, 
    10: 1135, 
    11: 1250, 
    12: 1365, 
    13: 1480, 
    14: 1595, 
    15: 1710, 
    16: 1825, 
    17: 1940, 
    18: 2055, 
    19: 2170, 
    20: 2285 
};

export const PRIMARY_TIMELINE_COLORS  = [
    "#ff8a00",
    "#db324d",
    "#4a8020",
    "#6a00f1",
    "#0076e9",
    "#E07746",
    "#464BE0",
    "#5A5C8B",
    "#54614E",
    "#4E5B61",
    "#8B5A5E",
    "#E04655",
    "#E0DB46"
];

export const SECONDARY_TIMELINE_COLOR  = [
    "#faca91",
    "#db8a97",
    "#9bbf7e",
    "#bb97e8",
    "#9abfe3",
    "#E07746",
    "#464BE0",
    "#5A5C8B",
    "#54614E",
    "#4E5B61",
    "#8B5A5E",
    "#E04655",
    "#E0DB46"
];

export const AUXILIAR_TIMELINE_COLOR = [
    "orange", 
    "red", 
    "green", 
    "purple", 
    "blue",
    "#E07746",
    "#464BE0",
    "#5A5C8B",
    "#54614E",
    "#4E5B61",
    "#8B5A5E",
    "#E04655",
    "#E0DB46"
];

export const MAP_STYLE = {
    dark: [
        { "elementType": "geometry", "stylers": [ { "color": "#125082" } ] },
        { "featureType": "administrative", "elementType": "geometry", "stylers": [ { "visibility": "off" } ] },
        { "featureType": "administrative.neighborhood", "stylers": [ { "visibility": "off" } ] },
        { "featureType": "poi", "stylers": [ { "visibility": "off" } ] },
        { "featureType": "road", "stylers": [ { "color": "#3777ab" } ] },
        { "featureType": "road", "elementType": "labels.icon", "stylers": [ { "visibility": "off"  } ] },
        { "featureType": "transit", "stylers": [ { "visibility": "off" } ] },
        { "featureType": "water", "elementType": "geometry", "stylers": [ {  "color": "#85b1d4" } ]        },
        { stylers: [ { lightness: -50, }, { saturation: 0} ] }
    ],
    light: [
        { "featureType": "administrative", "elementType": "geometry", "stylers": [ { "visibility": "off" } ] },
        { "featureType": "administrative.neighborhood", "stylers": [ { "visibility": "off" } ] },
        { "featureType": "poi", "stylers": [ { "visibility": "off" } ] },
        { "featureType": "road", "stylers": [ { "visibility": "on" } ] },
        { "featureType": "road", "elementType": "labels.icon", "stylers": [ { "visibility": "off"  } ] },
        { "featureType": "transit", "stylers": [ { "visibility": "off" } ] },
        { stylers: [ { lightness: 0, }, { saturation: 0 } ] }
    ]
}

export const MAP_CONFIG = {
    zoom: 16,
    disableDefaultUI: false,
    panControl: false,
    zoomControl: false,
    mapTypeControl: false,
    scaleControl: false,
    streetViewControl: false,
    fullscreenControl: false,
}

export const LOCATION_ICON = (iconColor, itemLabel) => `
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 36 50" style="enable-background:new 0 0 36 50;" xml:space="preserve">
        <path style="fill: ${iconColor}; stroke: #1C4963; stroke-width: 2;" d="M18,47l-0.7,0.7l0.7,0.7l0.7-0.7L18,47z M18,47c0.7,0.7,0.7,0.7,0.7,0.7l0,0l0,0l0,0l0,0c0,0,0.1-0.1,0.1-0.1
        c0.1-0.1,0.3-0.3,0.5-0.5c0.4-0.5,1.1-1.1,1.8-2c1.5-1.7,3.5-4.1,5.5-6.9c2-2.8,4-6,5.5-9.3c1.5-3.3,2.6-6.7,2.6-9.9
        C34.8,9.1,27.3,1,18,1C8.7,1,1.2,9.1,1.2,18.9c0,3.2,1,6.7,2.6,9.9c1.5,3.3,3.5,6.5,5.5,9.3c2,2.8,4,5.2,5.5,6.9
        c0.7,0.9,1.4,1.5,1.8,2c0.2,0.2,0.4,0.4,0.5,0.5c0.1,0.1,0.1,0.1,0.1,0.1l0,0l0,0l0,0l0,0C17.3,47.7,17.3,47.7,18,47z"/>
        <ellipse style="fill: ${iconColor}; stroke: #FFFFFF; stroke-width: 2;" cx="18" cy="18.6" rx="12.3" ry="12.6"/>
        <text x="18" y="23.5" text-anchor="middle" style="fill: #FFFFFF; font-family:'PoppinsBold'; font-size:18px;">${itemLabel}</text>
    </svg>
`